<template>
	<page>
		<module>
<!--			<div class="order-state flex-between-center">
				<div>
                    <h1>{{title}}</h1>
					<p>请处理退货申请</p>
				</div>
				
				&lt;!&ndash; <node-list :nodes="nodeList"></node-list> &ndash;&gt;
			</div>-->
			
			<div class="order-detail flex">
				<dl class="order-info">
					<dt class="flex-between-center">
						<p>退款单号：{{afterSalesDetail.refund_number || afterSalesDetail.return_number}}</p>
						<c-button @click="$copy(afterSalesDetail.refund_number || afterSalesDetail.return_number)">复制</c-button>
					</dt>
					<dd>
						<div class="order-info-item flex">
							<label>关联订单：</label>
							<p><a @click="navigateTo(`/order_detail/${afterSalesDetail.order_number}`)">{{afterSalesDetail.order_number}}</a></p>
						</div>
						<div class="order-info-item flex">
							<label>运营模式：</label>
							<p>{{orderInfo.operation_mode==1?'平台自营':'商家自营'}}</p>
						</div>
						<div class="order-info-item flex">
							<label>所属商家：</label>
							<p>{{orderInfo.stationed_name}}</p>
						</div>
						<div class="order-info-item flex">
							<label>订单状态：</label>
							<p>
								<span style="color:#182eff">{{orderStateName[orderInfo.order_state]}}</span>
							</p>
						</div>
						<div class="order-info-item flex" v-if="orderInfo.operation_mode==2">
							<label>买家账号：</label>
							<p>{{orderInfo.user_login_name}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderInfo.operation_mode==2 && orderInfo.receiving_name && orderInfo.receiving_phone && orderInfo.receiving_address">
							<label>收货信息：</label>
							<p>{{orderInfo.receiving_name}}，{{orderInfo.receiving_phone}}（{{orderInfo.receiving_address}}）</p>
						</div>
						<div class="order-info-item flex">
							<label>下单时间：</label>
							<p class="flex-grow flex-between">
								<span>{{orderInfo.create_date}}</span>
								<!-- <a>更多...</a> -->
							</p>
						</div>
						<!-- <div class="order-info-item flex" v-if="orderInfo.operation_mode==2">
							<label>已支付：</label>
                            <p v-if="orderInfo.payment_state != 2"><b>￥{{parseFloat(orderInfo.payment_money).toFixed(2)}}</b>
                                （
                                含运费：￥{{parseFloat(orderInfo.logistics_money).toFixed(2)}}
                                <span v-if="orderInfo.order_type==7 && customInfo">
                                        &nbsp;&nbsp;定制费:￥{{parseFloat(customInfo.product_price_cost_money).toFixed(2)}}
                                    </span>
                                ）
                            </p>
						</div> -->
						<div class="order-info-item flex" v-if="orderInfo.operation_mode==2 && afterSalesDetail.push_state == 2">
							<label>售后三方单号：</label>
							<p v-if="type == 'refund'">{{afterSalesDetail.out_refund_number}}</p>
							<p v-else>{{afterSalesDetail.out_return_number}}</p>
						</div>
						<div class="order-info-item flex" v-if="type == 'return' && afterSalesDetail.push_state == 2">
							<label>售后收货状态：</label>
							<p v-if="afterSalesDetail.receiving_state == 0">待收货</p>
							<p v-else>已收货</p>
						</div>
					</dd>
				</dl>
				
				<div class="order-node flex-grow">
					<h1>{{afterSalesState}}</h1>
					<div class="order-node-content">
						<ul class="flex-wrap">
							<li class="flex">
								<label>申请时间：</label>
								<p>{{afterSalesDetail.create_date}}</p>
							</li>
							
							<template v-if="type == 'refund' && afterSalesDetail.refund_type != 3">
								<li class="flex">
									<label>服务费退款：</label>
									<p>￥{{parseFloat(afterSalesDetail.product_money).toFixed(2)}}</p>
								</li>
								<li class="flex">
									<label>退款原因：</label>
									<p>{{afterSalesDetail.refund_reason_type_name}}{{afterSalesDetail.refund_reason ? afterSalesDetail.refund_reason:''}}</p>
								</li>
							</template>
							
							<template v-else-if="type == 'refund' && afterSalesDetail.refund_type == 3">
								<li class="flex">
									<label>申请原因：</label>
									<p>{{afterSalesDetail.return_reason_type_name}}{{afterSalesDetail.return_reason ? '（'+afterSalesDetail.return_reason+'）':''}}</p>
								</li>
								<li class="flex">
									<label>申请数量：</label>
									<p>{{afterSalesDetail.product_count}}</p>
								</li>
								<li class="flex">
									<label>申请退款：</label>
									<p>￥{{parseFloat(afterSalesDetail.refund_total_money).toFixed(2)}}</p>
								</li>
							</template>
							
							<template v-else>
								<li class="flex">
									<label>申请原因：</label>
									<p>{{afterSalesDetail.return_reason_type_name}}{{afterSalesDetail.return_reason ? '（'+afterSalesDetail.return_reason+'）':''}}</p>
								</li>
								<li class="flex">
									<label>申请数量：</label>
									<p>{{afterSalesDetail.product_count}}</p>
								</li>
                                <li class="flex">
                                  <label>服务退款：</label>
                                  <p>￥{{parseFloat(afterSalesDetail.product_money).toFixed(2)}}</p>
                                </li>
                                <li class="flex" v-if="orderInfo.operation_mode==2">
                                  <label>运费退款：</label>
                                  <p>￥{{parseFloat(afterSalesDetail.logistics_money).toFixed(2)}}</p>
                                </li>
							</template>
							
							<li v-if="afterSalesDetail.audit_date" class="flex">
								<label>审批时间：</label>
								<p>{{afterSalesDetail.audit_date}}</p>
							</li>
							
							<li v-if="afterSalesDetail.audit_reject_reason" class="flex">
								<label>驳回原因：</label>
								<p>{{afterSalesDetail.audit_reject_reason}}</p>
							</li>
							
							<template v-if="type == 'return'">
								<li v-if="afterSalesDetail.return_logistics_company" class="flex">
									<label>退回物流：</label>
									<p>{{afterSalesDetail.return_logistics_company}}</p>
								</li>
                                <li v-if="afterSalesDetail.return_voucher_img_url && afterSalesDetail.return_voucher_img_url!=''" class="flex">
                                    <label>退回凭证：</label>
                                    <div class="preview">
                                        <c-file class="image" :src="afterSalesDetail.return_voucher_img_url" media></c-file>
                                    </div>
                                </li>
								<li v-if="afterSalesDetail.return_logistics_date" class="flex">
									<label>退回时间：</label>
									<p>{{afterSalesDetail.return_logistics_date}}</p>
								</li>
								<li v-if="afterSalesDetail.remitter_date" class="flex">
									<label>退款到账时间：</label>
									<p>{{afterSalesDetail.remitter_date}}</p>
								</li>
							</template>
						</ul>
					</div>
					<div class="order-total">
						<template v-if="type == 'refund'">
							<!-- <span>申请数量：{{afterSalesDetail.product_count}}件</span> -->
                            <span v-if="afterSalesDetail.refund_type != 3 && customInfo">申请退款：￥{{(afterSalesDetail.product_money + afterSalesDetail.logistics_money + afterSalesDetail.other_fee + (customInfo.product_price_cost_money||0)).toFixed(2)}}</span>
                            <span v-else-if="afterSalesDetail.refund_type != 3 && !customInfo">申请退款：￥{{(afterSalesDetail.product_money + afterSalesDetail.logistics_money + afterSalesDetail.other_fee).toFixed(2)}}</span>
							<span v-else>申请退款：￥{{(afterSalesDetail.refund_total_money).toFixed(2)}}</span>
							<span v-if="afterSalesDetail.state == 2">实退金额：<b>￥{{parseFloat(afterSalesDetail.refund_total_money).toFixed(2)}}</b></span>
						</template>
						<template v-else>
							<!-- <span>申请数量：{{afterSalesDetail.product_count}}件</span> -->
							<span>申请退款：￥{{(parseFloat(afterSalesDetail.product_money)+parseFloat(afterSalesDetail.logistics_money)).toFixed(2)}}</span>
							<span v-if="afterSalesDetail.return_state == 5 && orderInfo.operation_mode==2">扣款金额：<b>￥{{parseFloat(afterSalesDetail.debit_money).toFixed(2)}}</b></span>
							<span v-if="afterSalesDetail.return_state == 5">实退金额：<b>￥{{parseFloat(afterSalesDetail.return_total_money).toFixed(2)}}</b></span>
						</template>
					</div>
				</div>
			</div>
		</module>
		
		<module>
			<div class="order-detail">
				<c-table :data="productList" :paging="false" border>
					<c-table-column
						label="服务信息"
						width="300"
					>
                        <template #default="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                        </template>
					</c-table-column>
					
					<c-table-column
						label="规格信息"
						name="product_sku_spec"
					></c-table-column>
					
					<c-table-column v-if="type == 'return'"
						label="单价"
					>
						<template v-slot="{data}">
							￥{{parseFloat(data.product_order_unit_price).toFixed(2)}}
						</template>
					</c-table-column>
					
					<!-- <c-table-column
						:label="type == 'refund' ? '退款数' : '退货数'"
					>
						<template v-slot="{data}">
							{{data.product_count}}
						</template>
					</c-table-column> -->
					
					<template v-if="refundType != 3">
						<c-table-column
							label="实付金额"
						>
							<template v-slot="{data}">
								<span style="color:dodgerblue">￥{{parseFloat(data.product_money).toFixed(2)}}</span>
							</template>
						</c-table-column>
					</template>
					
					<template v-if="type == 'return'">
						<c-table-column
							label="凭证"
						>
							<template v-slot="{data}">
                                <div  class="flex-center-cross" v-if="data.voucher_img_arr">
                                    <c-image v-for="(medias, j) in data.voucher_img_arr" :key="j" class="img" :src="medias" size="80" preview></c-image>
                                </div>
                                <span v-else>--</span>
							</template>
						</c-table-column>
					
						<c-table-column
							label="扣款金额"
                            v-if="orderInfo.operation_mode==2"
						>
							<template v-slot="{data}">
								￥{{parseFloat(data.debit_money).toFixed(2)}}
							</template>
						</c-table-column>
					</template>
				</c-table>
			</div>
			
			<template slot="button" v-if="orderInfo.operation_mode == 2">
				<template v-if="type == 'refund'">
					<template v-if="auth('b_order_refund_check') && afterSalesDetail.state == 1">
						<c-button size="form" color="main" @click="refundVerifyHandle('resolve')">同意申请</c-button>
						<c-button size="form" color="red" @click="refundVerifyHandle('reject')">驳回申请</c-button>
					</template>
				</template>
				<template v-else>
					<template v-if="auth('b_order_return_check') && afterSalesDetail.return_state == 1">
                        <div v-if="orderInfo.order_classify == 1 || orderInfo.order_classify == 3">
                            <c-button size="form" color="main" @click="returnVerifyHandle('resolve')">同意申请</c-button>
                            <c-button size="form" color="red" @click="returnVerifyHandle('reject')">驳回申请</c-button>
                        </div>
                        <div v-else>
                            <c-button size="form" color="main" @click="returnVerifyHandle('return')">同意申请并打款</c-button>
                        </div>
					</template>
					<template v-if="auth('b_order_return_finance_check') && afterSalesDetail.return_state == 3">
						<c-button size="form" color="main" @click="returnVerifyHandle('return')">确认收货并打款</c-button>
						<c-button size="form" color="red" @click="returnVerifyHandle('reject')">驳回申请</c-button>
					</template>
				</template>
			</template>
		</module>
		
		<c-dialog ref="rejectReason" title="驳回原因" width="550" button-name="确认驳回" @resolve="rejectHandle">
			<div class="order-verify">
				<textarea v-model="rejectReason" placeholder="请输入驳回原因..."></textarea>
			</div>
		</c-dialog>
		
		<c-dialog ref="returnAddress" title="同意退货" width="650" height="300" button-name="确认同意" @resolve="returnResolveHandle">
			<div class="order-verify">
				<div class="address flex-between-center">
					<p><b>*</b>请选择退货地址：</p>
					<div>
						<c-link v-if="auth('b_after_sale_address')"  href="/logistics_tool?tab=2" target="_blank">设置退货地址</c-link>
						<a @click="getReturnAddress">刷新</a>
					</div>
				</div>
				
				<c-radio-group v-model="returnAddress" column>
					<c-radio v-for="(item, i) in returnAddressOptions" :key="i" :value="item.value">{{item.name}}</c-radio>
				</c-radio-group>
			</div>
		</c-dialog>
		
		<c-dialog ref="returnDebit" title="售后服务扣款" width="1000" button-name="确认并打款" @resolve="returnRemitHandle">
			<c-table ref="returnDebitList" :data="debitList" height="400" :paging="false">
				<c-table-column
					label="服务信息"
					width="200"
				>
                    <template #default="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
				</c-table-column>
				
				<c-table-column
					label="规格信息"
					name="product_sku_spec"
				></c-table-column>
				
				<c-table-column
					label="单价"
				>
					<template v-slot="{data}">
						￥{{data.product_order_unit_price}}
					</template>
				</c-table-column>
				
				<c-table-column
					:label="type == 'refund' ? '退款数' : '退货数'"
				>
					<template v-slot="{data}">
						×{{data.product_count}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="实付金额"
				>
					<template v-slot="{data}">
						￥{{data.product_money}}
					</template>
				</c-table-column>
				
				<template v-if="type == 'return'">
					<c-table-column
						label="凭证"
					>
						<template v-slot="{data}">
                            <div  class="flex-center-cross" v-if="data.voucher_img_arr">
                                <c-image v-for="(medias, j) in data.voucher_img_arr" :key="j" class="img" :src="medias" size="80" preview></c-image>
                            </div>
                            <span v-else>--</span>
						</template>
					</c-table-column>
				
					<c-table-column
						label="扣款金额"
                        v-if="(orderInfo.order_classify == 1 || orderInfo.order_classify == 3)"
                    >
						<template v-slot="{data}">
							<c-input v-model="data.debit_money" type="number" decimal="2" :limit="data.product_money"></c-input>
						</template>
					</c-table-column>
					
					<c-table-column
						label="实退金额"
					>
						<template v-slot="{data}">
							￥{{parseFloat((data.product_money - (parseFloat(data.debit_money) || 0)).toFixed(2))}}
						</template>
					</c-table-column>
				</template>
			</c-table>
		</c-dialog>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	
	export default {
		components: {
			// nodeList,
			productInfo
		},
		
		props: {
			type: String,
			orderNumber: String,
			refundType: String
		},
		
		data() {
			return {
				orderStateName: {
					0: '待报价',
					1: '待付款',
					2: '待审核',
					3: '服务中',
					4: '待验收',
					5: '交易完结',
					6: '已关闭'
				},
				afterSalesDetail: {},
				orderInfo: {},
                customInfo: {},
                preOrderInfo: {},
				productList: [],
				
				returnAddressList: [],
				returnAddress: '',
				rejectReason: '',
				debitList: [],
                returnType:1  //售后类型  1（需要寄回货物）；2（仅退款，无需寄回货物）
			}
		},
		
		computed: {
            title(){
                var result = "";
                if (this.type == 'refund'){
                    result = "未发退款";
                }else {
                    if (this.returnType == 1){
                        result = "【已发】退货退款（需要寄回服务）";
                    }else {
                        result = "【已发】仅退款（无需寄回服务）";
                    }
                }
                return result;
            },

			orderState() {
				return {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				}[this.orderInfo.order_state];
			},
			
			afterSalesState() {
				if (this.type == 'refund') {
					return {
						1: '待审核',
						2: '审核通过',
						3: '已驳回',
						4: '已撤销'
					}[this.afterSalesDetail.state];
				} else {
					return {
						1: '待审核',
						2: '待用户退货',
						3: '待财务打款',
						5: '退款成功',
						6: '已驳回',
						8: '已撤销'
					}[this.afterSalesDetail.return_state];
				}
			},
			
			nodeList() {
				if (this.type == 'refund') {
					//退款单状态   1-待审核  、 2 审核通过  、 3 已驳回 、4 已撤销
					let state = this.afterSalesDetail.state;
					if (state == 3){
						return [{
						  name: '提交申请'
						}, {
						  name: '申请驳回'
						}];
					}else if(state == 4){
						return [{
						  name: '提交申请'
						}, {
						  name: '申请撤销'
						}];
					}else {
						return [{
						  name: '提交申请'
						}, {
						  name: '退款审批',
						  current: state == 1
						}, {
						  name: '退款完结',
						  current: state == 1
						}];
					}
				} else {
					//申请状态   1-待审核、  2：待用户退货 、3：待财务打款、5 退款成功、 6 申请驳回 、 8：申请撤销
					let state = this.afterSalesDetail.return_state;
					console.log(state)
					if (state == 6){
						return [{
						  name: '提交申请'
						}, {
						  name: '申请驳回'
						}];
					}else if(state == 8){
						return [{
						  name: '提交申请'
						}, {
						  name: '申请撤销'
						}];
					}else{
						return [{
						  name: '提交申请'
						}, {
						  name: '退货审批',current: state == 1
						}, {
						  name: '买家退货',current: state == 2
						}, {
						  name: '财务审批',current: state == 3
						}, {
						  name: '退款完结', current: state == 3
						}];
					}
				}
			},
			
			returnAddressOptions() {
				return Array.from(this.returnAddressList, item => {
					return {
						name: `${item.after_sale_name}，${item.after_sale_mobile}，${item.after_sale_address}`,
						value: item.id
					}
				});
			}
		},
		
		watch: {
			orderNumber() {
				this.getAfterSalesDetail();
			}
		},
		
		mounted() {
			this.getAfterSalesDetail();
		},
		
		methods: {
			getAfterSalesDetail() {
				this.request({
					url: this.type == 'refund' ? '/refund/detail' : '/returns/detail',
					data: {
						[this.type == 'refund' ? 'refund_number' : 'return_number']: this.orderNumber,
					},
					loading: true,
					success: data => {
						this.afterSalesDetail = data.base_info;
						this.orderInfo = data.order_info;
                        this.customInfo = data.custom_info;
                        this.preOrderInfo = data.pre_order_info;
						this.productList = data.product_info || data.return_product_list;
                        this.returnType = data.base_info.return_type||0;
					}
				});
			},
			
			refundVerifyHandle(type, confirm) {
				if (type == 'resolve') {
					this.$confirm({
						message: '确定要对该退款单立即执行退款操作吗？',
						resolve: () => {
							this.request({
								url: '/refund/approval',
								data: {
									refund_number: this.orderNumber
								},
								loading: true,
								success: () => {
									this.$message({
										message: '订单退款成功'
									});
									this.getAfterSalesDetail();
								}
							});
						}
					});
				} else if (confirm) {
					this.request({
						url: '/refund/reject',
						data: {
							refund_number: this.orderNumber,
							refund_reject_reason: this.rejectReason.trim()
						},
						loading: true,
						success: () => {
							this.$message({
								message: '申请已驳回'
							});
							this.getAfterSalesDetail();
						}
					});
				} else {
					this.rejectHandle();
				}
			},
			returnVerifyHandle(type, confirm) {
				if (type == 'resolve' && !confirm) {
                    if (this.returnType == 1){
                        this.returnResolveHandle();
                    }else {
                        this.checkReturnMoneyOnlyOrder();
                    }
					return;
				} else if (type == 'reject' && !confirm) {
					this.rejectHandle();
					return;
				} else if (type == 'return' && !confirm) {
					this.returnRemitHandle();
					return;
				}
				
				let returnAddress;
				if (type == 'resolve') {
					returnAddress = this.returnAddressList.find(item => item.id == this.returnAddress);
				}
				
				this.request({
					url: '/returns/check',
					data: Object.assign({
						return_number: this.orderNumber,
						return_state: type == 'return' ? 5 : type == 'reject' ? 6 : 2,
						audit_reject_reason: this.rejectReason.trim(),
						return_skus: type == 'return' ? Array.from(this.debitList, item => {
							return {
								product_sku: item.product_sku,
								debit_money: parseFloat(item.debit_money) || 0
							}
						}) : ''
					}, type == 'resolve' ? {
						return_after_sale_name: returnAddress.after_sale_name,
						return_after_sale_mobile: returnAddress.after_sale_mobile,
						return_after_sale_address: returnAddress.after_sale_address
					} : {}),
					loading: true,
					success: () => {
						this.$message({
							message: '操作成功'
						});
						this.getAfterSalesDetail();
					}
				});
			},

            //仅退款的收货单
            checkReturnMoneyOnlyOrder(){
                this.$confirm({
                    message: '是否确认同意售后单【'+this.orderNumber+'】进行仅退款？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/returns/check',
                            data:{
                                return_number: this.orderNumber,
                                return_state: 3 //待财务打款
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.getAfterSalesDetail();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
			
			returnResolveHandle(stop) {
				if (!stop) {
					if (!this.returnAddressOptions.length) {
						this.getReturnAddress();
					}
					this.returnAddress = '';
					this.$refs.returnAddress.open();
				} else {
					stop();
						
					if (!this.returnAddress) {
						this.$message({
							message: '请选择退货地址'
						});
						return;
					}
						
					this.returnVerifyHandle('resolve', true);
					this.$refs.returnAddress.close();
				}
			},
			
			getReturnAddress() {
				this.request({
					url: '/after_sale_address/list',
					data: {
						pageIndex: 1,
						pageSize: 20,
						state: [2]
					},
					loading: true,
					success: data => {
						this.returnAddressList = data;
					}
				});
			},
			
			returnRemitHandle(stop) {
				if (!stop) {
					this.request({
						url: '/returns/detail',
						data: {
							return_number: this.orderNumber,
						},
						loading: true,
						success: data => {
							this.debitList = data.return_product_list;
							this.$refs.returnDebit.open();
						}
					});
				} else {
					stop();
					
					var total = 0;
					this.debitList.forEach(item => {
						total += parseFloat(item.debit_money) || 0;
					});
					
					this.$confirm({
						message: `确定要对该退货退款单立即执行打款操作吗？<br>(申请金额:￥${(this.afterSalesDetail.product_money+this.afterSalesDetail.logistics_money).toFixed(2)}，实退金额:<span style="color: #f00">￥${(this.afterSalesDetail.product_money +this.afterSalesDetail.logistics_money - parseFloat(total.toFixed(2))).toFixed(2)}</span>)`,
						resolve: () => {
							this.returnVerifyHandle('return', true);
							this.$refs.returnDebit.close();
						}
					});
					
				}
			},
			
			rejectHandle(stop) {
				if (!stop) {
					this.rejectReason = '';
					this.$refs.rejectReason.open();
				} else {
					stop();
						
					if (!this.rejectReason.trim()) {
						this.$message({
							message: '请填写驳回原因'
						});
						return;
					}
					
					this[`${this.type}VerifyHandle`]('reject', true);
					this.$refs.rejectReason.close();
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		&-state {
			height: 120px;
			padding: 0 34px;
			color: #fff;
			background: #622F8A;
			background-image: url('~@/assets/image/order_detail_state_bg.png');
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;
			
			h1 {
				font-size: 24px;
			}
			
			p {
				font-size: 13px;
				margin-top: 15px;
			}
		}
		
		&-detail {
			padding: 30px;
		}
		
		&-info {
			width: 38%;
			border: 1px solid #ddd;
			
			dt {
				height: 42px;
				border-bottom: 1px solid #ddd;
				padding: 0 12px 0 16px;
				
				p {
					font-size: 13px;
					font-weight: bold;
				}
			}
			
			dd {
				padding: 12px 25px 12px 18px;
			}
			
			&-item {
				padding: 6px 0;
				line-height: 20px;
				font-size: 12px;
				
				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}
				
				p {
					a {
						color: #003DD9;
					}
				}
			}
		}
		
		&-node {
			border: 1px solid #ddd;
			border-left: none;
			padding: 0 20px;
			
			h1 {
				line-height: 106px;
				font-size: 24px;
				font-weight: normal;
				text-align: center;
			}
			
			&-content {
				padding: 30px 0 40px 14%;
				background: #FAFAFA;
			
				li {
					box-sizing: border-box;
					width: 50%;
					padding: 8px 20px 8px 0;
					line-height: 20px;
					font-size: 13px;
					
					label {
						min-width: 7em;
						color: #666;
						text-align: right;
					}
					
					p {
						a {
							color: #003DD9;
						}
					}
				}
			}
		}
		
		&-total {
			padding: 16px 0;
			font-size: 13px;
			text-align: right;
			
			span {
				margin-left: 2em;
			}
			
			b {
				color: var(--color-main);
			}
		}
		
		&-verify {
			padding: 20px;
			
			.address {
				font-size: 13px;
				
				b {
					margin-right: 4px;
					color: #f00;
				}
				
				a {
					margin-left: 15px;
					color: #003DD9;
				}
			}
			
			.c-radio-group {
				margin: 20px 0;
			}
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}
		
	.product {
		&-info {
			margin-left: 18px;
			line-height: 24px;
			font-size: 12px;
			color: #444;
		}
	}
	
	.logistics {
		&-order {
			padding: 14px 18px;
			
			li {
				border: 1px solid #ddd;
				padding: 0 26px;
				line-height: 42px;
				font-size: 14px;
				color: #666;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 20px;
				}
				
				&:hover {
					background: #F0F3FC;
				}
				
				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}
		
		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;
			
			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;
				
				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}
</style>